import { createContext } from 'react';
import { MessageInstance } from 'antd/es/message/interface';
import { Modal } from 'antd';

export interface FirestoreWriteErrorOptions {
  userMessage?: string;
  onError?: (error: Error) => void;
  /** Pending-save id of the write; when set, flags that save as failed in the saving store. */
  saveId?: string;
}

export interface MessageContextType {
  messageApi: MessageInstance;
  modal: ReturnType<typeof Modal.useModal>[0];
  handleFirestoreWriteError: (error: unknown, context: string, options?: FirestoreWriteErrorOptions) => Error;
}

export const MessageContext = createContext<MessageContextType>({} as MessageContextType);